import { render, staticRenderFns } from "./assigned_modal.vue?vue&type=template&id=4275d029&"
import script from "./assigned_modal.vue?vue&type=script&lang=js&"
export * from "./assigned_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports